import React from 'react';

const STACKS = [
  {
    id: 'grant',
    label: 'Business Grant Proposal',
    color: '#1a6e3c',
    position: 'left',
    pages: [
      '/images/sample_pages/grant_page_1.png',
      '/images/sample_pages/grant_page_2.png',
      '/images/sample_pages/grant_page_3.png',
    ],
  },
  {
    id: 'bp',
    label: 'Business Plan & Funding',
    color: '#1a3a6e',
    position: 'center',
    pages: [
      '/images/sample_pages/bp_page_1.png',
      '/images/sample_pages/bp_page_2.png',
      '/images/sample_pages/bp_page_3.png',
    ],
  },
  {
    id: 'sp',
    label: 'Service Proposal',
    color: '#1a2e5e',
    position: 'right',
    pages: [
      '/images/sample_pages/sp_page_1.png',
      '/images/sample_pages/sp_page_2.png',
      '/images/sample_pages/sp_page_3.png',
    ],
  },
];

/** Back → front per stack (cover = pages[0] rendered last). */
const FAN_LAYERS = {
  center: [
    { rotation: -14, translateX: -40, zIndex: 1 },
    { rotation: 0, translateX: 0, zIndex: 2 },
    { rotation: 14, translateX: 40, zIndex: 3 },
  ],
  left: [
    { rotation: -18, translateX: -45, zIndex: 1 },
    { rotation: -6, translateX: -15, zIndex: 2 },
    { rotation: 6, translateX: 0, zIndex: 3 },
  ],
  right: [
    { rotation: 18, translateX: 45, zIndex: 1 },
    { rotation: 6, translateX: 15, zIndex: 2 },
    { rotation: -6, translateX: 0, zIndex: 3 },
  ],
};

const POSITION_CLASSES = {
  center: 'left-1/2 top-0 z-[2] -translate-x-1/2 items-center text-center',
  left: 'left-0 top-[80px] z-[1] items-start text-left',
  right: 'right-0 top-[80px] z-[1] items-end text-right',
};

function DocumentStack({ stack }) {
  const layers = FAN_LAYERS[stack.position];

  return (
    <div
      className={`absolute flex flex-col ${POSITION_CLASSES[stack.position]}`}
      data-testid={`sample-stack-${stack.id}`}
    >
      <span
        className="mb-2.5 inline-block whitespace-nowrap rounded-[20px] px-3 py-1.5 text-[11px] font-semibold text-white"
        style={{ background: stack.color }}
      >
        {stack.label}
      </span>

      <div className="relative h-[180px] w-[200px] md:h-[250px] md:w-[260px]">
        {[...stack.pages].reverse().map((src, i) => {
          const layer = layers[i];
          const pageNum = stack.pages.length - i;
          return (
            <img
              key={src}
              src={src}
              alt={`${stack.label} page ${pageNum}`}
              className="fan-page absolute left-1/2 top-0 h-[180px] w-[130px] -translate-x-1/2 rounded-md border border-black/[0.08] object-cover object-top shadow-[0_6px_20px_rgba(0,0,0,0.18),0_2px_6px_rgba(0,0,0,0.1)] md:h-[250px] md:w-[180px]"
              style={{
                transform: `translateX(calc(-50% + ${layer.translateX}px * var(--fan-spread))) rotate(calc(${layer.rotation}deg * var(--fan-spread)))`,
                zIndex: layer.zIndex,
              }}
              loading="lazy"
            />
          );
        })}
      </div>
    </div>
  );
}

export default function SampleDocumentFan() {
  return (
    <>
      <style>{`
        .fan-composition {
          --fan-spread: 0.7;
        }
        @media (min-width: 768px) {
          .fan-composition {
            --fan-spread: 1;
          }
        }
      `}</style>
      <div
        className="fan-composition relative mt-8 hidden h-[420px] w-full min-[481px]:block"
        data-testid="sample-document-fan"
        aria-label="Sample business proposal document pages"
      >
        {STACKS.map((stack) => (
          <DocumentStack key={stack.id} stack={stack} />
        ))}
      </div>
    </>
  );
}
